export const bankAccountRoute = {
  BANK_ACCOUNT_LIST: '/bankAccount/list',
  BANK_ACCOUNT_DETAIL: '/bankAccount/detail/:recordId',
};
